import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { SignalStatusTypes } from '../../../enums/signal-status.enum';
import { SignalFilter } from '../../../models/signal-filter.model';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { SignalStatus } from 'src/app/web-api-client';

@Component({
  selector: 'app-signal-filter-form',
  templateUrl: './signal-filter-form.component.html',
  styleUrls: ['./signal-filter-form.component.scss']
})
export class SignalFilterFormComponent implements OnInit, OnDestroy {
  @Input() signalStatusesList: SignalStatus[] = [];
  @Input() initialFilter: SignalFilter = null;
  @Output() filterClicked = new EventEmitter<SignalFilter>();

  private subscriptions = new Subscription();
  public signalFilterForm: FormGroup;

  private _initialFilter: SignalFilter;

  private componentIntialized = false;

  constructor(
    private readonly fb: FormBuilder,
    private readonly changeDetectorRef: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    if(this.initialFilter) {
      this._initialFilter = JSON.parse(JSON.stringify(this.initialFilter));
    }
    this.initializeSignalFilterForm();
    this.componentIntialized = true;
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(!this.componentIntialized) {
      return;
    }

    if(changes.initialFilter && !changes.initialFilter.firstChange) {
      this._initialFilter = JSON.parse(JSON.stringify(this.initialFilter));
      this.initializeSignalFilterForm();
    }
  }

  public onSignalListFilterFormSubmit($event: SubmitEvent) {
    const startDate: Date = this.signalFilterForm.value.startDate ? new Date(this.signalFilterForm.value.startDate) : null;
    const endDate: Date = this.signalFilterForm.value.endDate ? new Date(this.signalFilterForm.value.endDate) : null;
    const signalStatusType: SignalStatusTypes = this.signalFilterForm.value.signalStatus || null;

    if(startDate !== null || endDate !== null || signalStatusType !== null) {
      const signalsSearchFilter: SignalFilter = {
        startDate, endDate, signalStatusType
      }

      this.filterClicked.emit(signalsSearchFilter);
    }
  }

  public clearFilters() {
    this.signalFilterForm.patchValue({
      startDate: null,
      endDate: null,
      signalStatus: null
    });

    this.changeDetectorRef.detectChanges();
  }

  public resetForm() {
    this.signalFilterForm.reset();
    this._initialFilter = null;
  }

  private initializeSignalFilterForm() {
    this.signalFilterForm = this.fb.group({
      startDate: [this._initialFilter ? this._initialFilter.startDate : null],
      endDate: [this._initialFilter ? this._initialFilter.endDate : null],
      signalStatus: [this._initialFilter ? this._initialFilter.signalStatusType : null]
    });
  }
}
